import { EvtHeader } from "components/header";
import React from "react";
import CasestudyLayout from "../layout";
import BasicDetailsForm from "../basic-details/form";

const UpdateCaseStudy = () => {
    return (
            <CasestudyLayout>
                <div className="flex-1">
                    <EvtHeader title="Update Case Study" />
                    <div className="p-6 max-w-md">
                        <BasicDetailsForm />
                    </div>
                </div>
            </CasestudyLayout>
    );
};

export default UpdateCaseStudy;